// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LandingPageLayout_wrapper__2tckP"};